import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@scania/tegel/loader';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { initializeMsal, msalAppConfig } from './app/auth.config';

async function initializeAndBootstrap() {
  try {

    defineCustomElements(window);
    console.log('✅ Scania Tegel custom elements loaded!');
    
    await initializeMsal();
    
    const enhancedAppConfig = {
      ...appConfig,
      providers: [...appConfig.providers, ...msalAppConfig.providers]
    };

    console.log('🎯 Starting application bootstrap with authenticated user...');
    await bootstrapApplication(AppComponent, enhancedAppConfig);

    console.log('🎉 Application loaded successfully with authentication!');
    
  } catch (error) {
    console.error('❌ Error during initialization:', error);
  }
}

// Inicia o processo
initializeAndBootstrap();